import { changelogRoute } from './../../../app.route';
import { Component, OnInit } from '@angular/core';
import {
    authenticationRoute,
    registerRoute,
    passwordResetInitRoute,
    settingsRoute
} from '../../../account';
import { faqRoute } from '../../../faq/faq.route';
import { conditionGeneraleRoute, mentionLegaleRoute } from '../../../app.route';
import { Route } from '@angular/router';
import { DEPOT_REQUETE_ROUTE } from '../../../depot-requete/depot-requete.route';
import { RATTACHEMENT_ROUTE } from '../../../rattachement';
import { UserService } from '../../../shared';
import { PAGE_TITLE_SUFFIX } from '../../../app.constants';


@Component({
    selector: 'jhi-plan-site',
    templateUrl: './plan-site.component.html',
    styleUrls: ['./plan-site.component.scss']
})
export class PlanSiteComponent implements OnInit {

    routes: Array<Route> = [
        Object.assign({}, authenticationRoute, { data: { needAuthentication: false, pageTitle: 'Connexion'}}),
        Object.assign({}, registerRoute, { data: { needAuthentication: false, pageTitle: 'Inscription'}}),
        passwordResetInitRoute,
        {
            path: '/',
            data: {
                needAuthentication: true,
                pageTitle: `Accueil${PAGE_TITLE_SUFFIX}`
            },
            children: [
                Object.assign({}, DEPOT_REQUETE_ROUTE,
                    {
                        data: {
                            pageTitle: `Déposer une requête${PAGE_TITLE_SUFFIX}`
                        }
                    }
                ),
                Object.assign({}, RATTACHEMENT_ROUTE,
                    {
                        data: {
                            pageTitle: `Entrer un code reçu par courrier${PAGE_TITLE_SUFFIX}`
                        }
                    }
                )
            ]
        },
        Object.assign({}, settingsRoute),
        Object.assign({}, faqRoute),
        Object.assign({}, conditionGeneraleRoute),
        Object.assign({}, mentionLegaleRoute),
        Object.assign({}, changelogRoute),
    ];

    private authRoutes = [registerRoute, passwordResetInitRoute, authenticationRoute];

    constructor(private userService: UserService) {

    }

    ngOnInit(): void {
        this.userService.getIsAuthenticated().subscribe(isAuthenticated => {
            this.routes.forEach(route => {
                this.handleRouteDisplay(route, isAuthenticated);
                if (this.hasChildren(route)) {
                    route.children.forEach(childRoute => this.handleRouteDisplay(childRoute, isAuthenticated));
                }
            });
        });
    }

    hasChildren(route: Route) {
        return route.children && route.children.length > 0;
    }

    private handleRouteDisplay(route: Route, isAuthenticated: boolean): void {
        route.data.hide = isAuthenticated ? this.authRoutes.some(r => r.path === route.path) : route.data.needAuthentication;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/footer/plan-site/plan-site.component.ts